var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("el-slider", {
        attrs: {
          min: _vm.min,
          max: _vm.max,
          marks: _vm.marks,
          "show-input": _vm.showInput,
          disabled: _vm.mode !== "edit"
        },
        model: {
          value: _vm.currentValue,
          callback: function($$v) {
            _vm.currentValue = $$v
          },
          expression: "currentValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }